import useAuthStore from "@shared-stores/auth.store";
import useStateStore from "@shared-stores/state.store";
import { computed } from "vue";
import User from "@shared-models/profile/user.model";

/**
 * L'état d'authentification et l'adhérent connecté, lus directement dans les stores.
 *
 * Des `computed` et non des copies entretenues par `watch` : ce composable est appelé hors
 * composant — les gardes de navigation le font à chaque changement de page —, et là rien ne
 * détruit un `watch`. Ils s'accumulaient. Une copie arrivait de surcroît un tick après le store,
 * de sorte qu'un appelant pressé lisait l'état précédent.
 *
 * Lecture seule : personne n'écrit dans ces deux valeurs, les stores font foi.
 */
export default function ()
{
	const authStore = useAuthStore();
	const stateStore = useStateStore();

	const isLoggedIn = computed<boolean>(() => authStore.isLoggedIn);
	const loggedUser = computed<User | null>(() => authStore.isLoggedIn ? stateStore.user : null);

	return {
		isLoggedIn,
		loggedUser
	};
}
